import { Component, OnInit } from '@angular/core';
import { ApiService } from '../shared/api.service';

@Component({
  selector: 'app-bulk-clone',
  templateUrl: './bulk-clone.component.html',
  styleUrls: ['./bulk-clone.component.css']
})
export class BulkCloneComponent implements OnInit {
  canEdit = false;
  loading = false;

  value = '';

  results = [];

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  isValidInput(inputValue: string): boolean | string {
    try {
      inputValue.split('\n').forEach((line, i) => {
        let row = line.split(',');
        if(row.length !== 2) {
          throw new Error(`Line ${i + 1} does not have 2 columns.`);
        }

        if(row[0].length === 0) {
          throw new Error(`Line ${i + 1}, column 1 has an empty column.`);
        }

        if(isNaN(parseInt(row[0])) && row[0].length !== 3) {
          throw new Error(`Line ${i + 1}, column 1 is not a valid identifier (assignment id or abbreviation).`);
        }

        if(row[1].length === 0) {
          throw new Error(`Line ${i + 1}, column 2 has an empty value.`);
        }

        if(row[1].length !== 2) {
          throw new Error(`Line ${i + 1}, column 2 is not a valid site abbreviation.`);
        }
      });
    } catch(e) {
      return e.message;
    }

    return true;
  }

  clone(): void {
    const validation = this.isValidInput(this.value);
    if(validation !== true) {
      this.results = [validation];
      return;
    }

    this.loading = true;
    this.api.doAction('post', 'clone', {
      action: 'clone',
      data: this.value
    }).subscribe(
      (data: string) => {
        this.loading = false;
        this.value = '';

        const results = data.split('\n');
        results.shift();
        this.results = results
          .filter(result => result != '')
          .map(result => {
            return result.split(',');
          }
        );
      },
      err => {
        this.loading = false;
        this.results = [];
        this.results.push(err.error.message);
      }
    );
  }

}
